
/* STICKY ADD TO CART BAR */
const stickySelect = document.getElementById('product-quantity-select-sticky');

if (stickySelect) {
	stickySelect.addEventListener('change', function() {
		const selectedStickyValue = stickySelect.value;

		const quantity_select = document.getElementById('product-quantity-select');
		const quantity_input = document.getElementById('product-quantity-input');

		if (quantity_select) {
			quantity_select.value = selectedStickyValue;
		}

		if (quantity_input) {
			quantity_input.value = selectedStickyValue;
		}
	});
}

const stickyAtc = document.getElementById('sticky-atc');

if (stickyAtc) {
	stickyAtc.addEventListener('click', function() {
		const productMain = stickyAtc.closest('.product--container');
		const submitButton = productMain ? productMain.querySelector('button[type="submit"]') : null;

		if (submitButton) {
			submitButton.click();
		}
	});
}

function initMultiBuy() {
	document.querySelectorAll('[data-multi-buy]').forEach((multiBuyBlock) => {
		if (multiBuyBlock.dataset.multiBuyInit === 'true') return;

		const productForm = multiBuyBlock.closest('form');
		const options = multiBuyBlock.querySelectorAll('[data-multi-buy-option]');
		const pickerTemplate = multiBuyBlock.querySelector('[data-multi-buy-template]');
		const addMore = multiBuyBlock.querySelector('[data-multi-buy-add-more]');
		if (!productForm || !options.length) return;

		function getGroups() {
			return Array.from(multiBuyBlock.querySelectorAll('[data-multi-buy-group]'));
		}

		function isSimpleMultiBuy() {
			return multiBuyBlock.dataset.multiBuyMode === 'simple';
		}

		function ordinal(number) {
			const remainder = number % 100;
			if (remainder >= 11 && remainder <= 13) return `${number}th`;

			switch (number % 10) {
				case 1: return `${number}st`;
				case 2: return `${number}nd`;
				case 3: return `${number}rd`;
				default: return `${number}th`;
			}
		}

		function getSaving(price, compareAtPrice) {
			const livePrice = Number(price) || 0;
			const referencePrice = Math.max(Number(compareAtPrice) || 0, livePrice);
			const discount = Number(multiBuyBlock.dataset.bundleDiscount) || 0;

			// Include the existing markdown in bundle savings, without raising a lower sale price.
			const targetPrice = referencePrice * (100 - Math.min(100, Math.max(0, discount))) / 100;
			const bundlePrice = Math.min(livePrice, Math.round(targetPrice));
			return Math.max(0, referencePrice - bundlePrice);
		}

		function updateSavings() {
			const savings = multiBuyBlock.querySelector('[data-multi-buy-savings]');
			const savingsValue = multiBuyBlock.querySelector('[data-multi-buy-savings-value]');
			const isMultiBuyMode = getGroups().length > 0;

			addMore?.classList.toggle('is-visible', isMultiBuyMode);
			savings?.classList.toggle('is-visible', isMultiBuyMode);
			if (!savingsValue || !isMultiBuyMode) return;

			const priceSelector = productForm.querySelector('#product-price-selector');
			let totalSaving = getSaving(priceSelector?.dataset.price, priceSelector?.dataset.compare_at_price);

			getGroups().forEach((group) => {
				const swatch = group.querySelector('[data-multi-buy-swatch].selected');
				if (swatch) totalSaving += getSaving(swatch.dataset.price, swatch.dataset.compareAtPrice);
			});

			savingsValue.textContent = new Intl.NumberFormat(multiBuyBlock.dataset.locale, {
				style: 'currency',
				currency: multiBuyBlock.dataset.currencyCode
			}).format(totalSaving / 100);
		}

		function selectSwatch(swatch) {
			const group = swatch.closest('[data-multi-buy-group]');
			if (!group || swatch.disabled) return;

			group.querySelectorAll('[data-multi-buy-swatch]').forEach((option) => {
				option.classList.toggle('selected', option === swatch);
			});

			updateSavings();
		}

		function bindGroup(group) {
			group.querySelectorAll('[data-multi-buy-swatch]').forEach((swatch) => {
				swatch.addEventListener('click', () => selectSwatch(swatch));
			});

			group.querySelector('[data-multi-buy-remove]')?.addEventListener('click', () => {
				group.classList.remove('is-visible');
				window.setTimeout(() => {
					group.remove();
					if (getGroups().length === 0) {
						// If no extra colour pickers, reselect 1
						setMultiBuyMode(1);
					} else {
						updateSavings();
					}
				}, 500);
			});
		}

		function createGroup() {
			if (isSimpleMultiBuy() || !pickerTemplate) return;

			const group = pickerTemplate.content.firstElementChild.cloneNode(true);
			multiBuyBlock.insertBefore(group, pickerTemplate);
			const title = group.querySelector('h5');
			if (title) title.textContent = `Select ${ordinal(getGroups().length + 1)} ${multiBuyBlock.dataset.productType} Colour`;

			bindGroup(group);
			requestAnimationFrame(() => group.classList.add('is-visible'));
			updateSavings();
		}

		function setMultiBuyMode(quantity) {
			const isMultiBuyMode = String(quantity) === '2';
			const needsGroup = isMultiBuyMode && !isSimpleMultiBuy() && getGroups().length === 0;

			if (needsGroup) createGroup();
			if (!isMultiBuyMode || isSimpleMultiBuy()) getGroups().forEach((group) => group.remove());

			options.forEach((option) => option.classList.toggle('is-selected', option.dataset.quantity === String(quantity)));
			if (!needsGroup) updateSavings();
		}

		options.forEach((option) => option.addEventListener('click', () => setMultiBuyMode(option.dataset.quantity)));
		addMore?.querySelector('button')?.addEventListener('click', createGroup);
		multiBuyBlock.addEventListener('multi-buy:update', updateSavings);
		multiBuyBlock.addEventListener('multi-buy:mode-change', () => {
			setMultiBuyMode(multiBuyBlock.querySelector('[data-multi-buy-option].is-selected')?.dataset.quantity || 1);
		});

		setMultiBuyMode(multiBuyBlock.querySelector('[data-multi-buy-option].is-selected')?.dataset.quantity || 1);
		multiBuyBlock.dataset.multiBuyInit = 'true';
	});
}

initMultiBuy();

window.Theme = window.Theme || {};
window.Theme.setMultiBuyMode = function(mode) {
	function applyMode() {
		const multiBuyBlocks = document.querySelectorAll('[data-multi-buy]');
		if (!multiBuyBlocks.length) return false;

		multiBuyBlocks.forEach((multiBuyBlock) => {
			multiBuyBlock.dataset.multiBuyMode = mode === 'simple' ? 'simple' : 'colours';
			multiBuyBlock.dispatchEvent(new Event('multi-buy:mode-change'));
		});

		return true;
	}

	if (!applyMode()) {
		document.addEventListener('DOMContentLoaded', applyMode, { once: true });
	}
};

let productGallery;
window.refreshProductGallery = function() {
	productGallery?.destroy();
	// Keep the main gallery separate from any cart popup on the same page.
	const root = document.querySelector('.product--outer > .product_gallery-column');
	productGallery = window.createProductGallery(root, {
		// Gift-card design selectors still use this public API.
		onChange: api => { window.productGalleryApi = api; }
	});
};
window.refreshProductGallery();

function productVariantChange(){
	// Handles variant options such as kids' hooded towel sizes and gift card values.
	// Colour swatches can load a different product via AJAX; sizes belong to that product's variants.
	const optionRadios = document.querySelectorAll('.product-options-style-radio .option-value-input');
	const productPrice = document.querySelector('.product--price ');
	const productComparePrice = document.querySelector('.product--compare-at-price');

	function updateSelectedVariant(event) {
		// Use the form containing the changed size, not another product form on the page.
		// The initial call has no event, so it falls back to the first product form.
		const scope = event?.target?.closest('form.ajax-submit') || document.querySelector('form.ajax-submit');
		if (!scope) return;

		// This markup is supplied by product.liquid and replaced when the featured product changes colour.
		// Reading its JSON here avoids using the previous colour's global variant data and variant IDs.
		const variantContainer = scope.querySelector('#selected-variant-id');
		const selectedVariantIdInput = variantContainer?.querySelector('input');
		const variantData = variantContainer?.querySelector('[data-product-variants]');
		if (!selectedVariantIdInput || !variantData) return;
		const product_variants = JSON.parse(variantData.textContent);
		const optionRadios = scope.querySelectorAll('.product-options-style-radio .option-value-input');
		const currentSectionId = variantContainer.dataset.sectionId;

		// Match checked radios to Shopify's option1/option2/option3 fields, including the selected size.
		const selectedOptions = {};
		optionRadios.forEach(radio => {
			if (radio.checked) {
				selectedOptions[`option${radio.dataset.optionIndex}`] = radio.value;
			}
		});

		// Test each alternative while keeping the other selected options fixed. Hide unavailable
		// framed choices, so size availability reflects this colour rather than the previous product.
		optionRadios.forEach(radio => {
			const optionName = radio.getAttribute('name').replace('-', '');
			let OptionOptions = { ...selectedOptions };

			if (optionName in OptionOptions) {
				OptionOptions[optionName] = radio.value;
			}

			const matchingVariant = product_variants.find(variant => {
				return Object.keys(OptionOptions).every(optionName => {
					return variant[optionName] === OptionOptions[optionName];
				});
			});

			if (matchingVariant && matchingVariant.available) {
				radio.nextElementSibling.style.display = "flex"
			} else {
					if (radio.nextElementSibling && radio.nextElementSibling.classList.contains('option-type-frame')) {
				radio.nextElementSibling.style.display = "none"
				}
			}
		});

		// Resolve the full option combination to the variant ID submitted when adding to cart.
		const selectedVariant = product_variants.find(variant => {
			return Object.keys(selectedOptions).every(optionName => {
				return variant[optionName] === selectedOptions[optionName];
			});
		});

		if (selectedVariant) {
			console.log('selectedVariant')
			selectedVariantIdInput.value = selectedVariant.id;
			// Product pages keep a shareable variant URL; a featured product must not alter the collection URL.
			if (!scope.closest('.featured-product--container')) updateProductUrl(selectedVariant.id);

			// Request the displayed product's URL, not window.location (which may be a collection).
			// URL/searchParams handles query separators and asks Liquid to render this size in the correct section.
			const sectionUrl = new URL(variantContainer.dataset.productUrl, window.location.origin);
			sectionUrl.searchParams.set('variant', selectedVariant.id);
			sectionUrl.searchParams.set('sections', currentSectionId);

			fetch(sectionUrl.toString())
			.then(response => response.text())
			.then(html => {

				// A colour swap disconnects the old container; another size selection changes the hidden ID.
				// Discard either response so slow requests cannot overwrite the currently selected product/size.
				if (!variantContainer.isConnected || selectedVariantIdInput.value !== String(selectedVariant.id)) return;
				const parsedHTML = JSON.parse(html)

				// Shopify's sections response maps section IDs to HTML rendered for the requested variant.
				const parsedSection = parsedHTML[currentSectionId]
				const parser = new DOMParser();
				const sectionHTML = parser.parseFromString(parsedSection, 'text/html');

				// Let Liquid supply the variant's button state, preorder fields and price instead of
				// duplicating those rules in JS. Leave the size radios/form in place with their event listeners.
				const sections_to_update = [
					".product-form--atc",
					"#product-price-selector"
				]

				sections_to_update.forEach(update_id => {
					// Update only this form, and skip elements absent from either version of the markup.
					if (scope.querySelector(update_id) && sectionHTML.querySelector(update_id)) {
						scope.querySelector(update_id).innerHTML = sectionHTML.querySelector(update_id).innerHTML;
					}
				});

				// Sizes can have different preorder shipment allocations. These elements sit
				// outside the ATC wrapper, so replace their visibility and progress styles too.
				for (const selector of ['.preorder-message.po-4', '.product-stock-progress']) {
					const current = scope.querySelector(selector);
					const incoming = sectionHTML.querySelector(selector);
					if (current && incoming) current.replaceWith(incoming.cloneNode(true));
				}
			})
			.catch(e => {
				console.error(e);
			});

		} else {
			// A nonexistent option combination has no variant to render; mark this form's CTA as disabled.
			const productCta = scope.querySelector('.product-form--atc-qty');
			const productCtaButton = productCta?.querySelector('#AddToCart');

			if (productCtaButton) {
				productCtaButton.classList.add('disabled');
			}
		}
	}

	function updateProductUrl(variantId) {
		const currentUrl = new URL(window.location.href);
		currentUrl.searchParams.set('variant', variantId);
		window.history.replaceState({}, '', currentUrl);
	}

	// Featured-product colour swaps retain these radios/listeners but replace the variant data above.
	// The next size change therefore resolves against the newly displayed colour.
	optionRadios.forEach(radio => {
		radio.addEventListener('change', updateSelectedVariant);
	});

	// Apply availability and render the initially checked options before the customer changes a size/value.
	const product_options_radio = document.querySelector('.product-options-style-radio');
	if (product_options_radio) {
		updateSelectedVariant();
	}
}

document.addEventListener('DOMContentLoaded', function () {
	productVariantChange();
});

function ajax_add_to_cart(){
	// Add To Cart
	// Not for bundles or 'all colours' products
	const productForm = document.querySelector('form.ajax-submit');
	if (!productForm) return;

	productForm.addEventListener('submit', (event) => {
		event.preventDefault();

		const selectedId = productForm.querySelector("input[name='id']").value;
		const submitButton = productForm.querySelector('#AddToCart, #add-single-product');
		let form_properties = {}

		// Keep line item properties scoped to this product form so unrelated
		// form fields elsewhere on the page are not accidentally included.
		const inputProperties = productForm.querySelectorAll('[name*="properties"]');
		inputProperties.forEach(input => {
			let nameValue = input.name;
			nameValue = nameValue.replace('properties[', '').replace(']', '');

			if ((input.type === "text" || input.type === "email" || input.tagName.toLowerCase() === "textarea") && input.value.trim() !== "" ) {
				form_properties[nameValue] = input.value
			}
			if (input.type === "radio" && input.checked){
				form_properties[nameValue] = input.value;
			}
			if (input.type === "checkbox" && input.checked){
					if (input.id === "recipient-checkbox") {
					form_properties[nameValue] = true
				} else {
					form_properties[nameValue] = input.value
				}
			}
			if ( input.type === "date"){
				form_properties[nameValue] = input.value
			}
		});

		const addToCartButton = productForm.querySelector('#AddToCart .atc-button--text');
		const addToCartButtonText = (addToCartButton?.textContent || '').trim().toLowerCase().replace(/\s+/g, '');
		const isPreorder = addToCartButtonText === 'pre-order';
		const quantitySelect = productForm.querySelector('[data-quantity-select]');
		const quantityInput = productForm.querySelector('[data-quantity-input]');
		const simpleMultiBuyOption = productForm.querySelector('[data-multi-buy-mode="simple"] [data-multi-buy-option].is-selected');
		const selectedQuantity = Number(simpleMultiBuyOption?.dataset.quantity || quantityInput?.value || quantitySelect?.value || 1) || 1;
		const isMultiBuyMode = productForm.querySelectorAll('[data-multi-buy-group]').length > 0;

		if (isPreorder && !form_properties.Preorder) {
			form_properties.Preorder = (
				submitButton?.dataset.preorderMessage ||
				'Pre-order'
			).trim();
		}

		//Check if any upsell selected
		let selected_variants = [
			{
				quantity: selectedQuantity,
				id: selectedId,
				// The main product should keep the same properties whether it is
				// added on its own or alongside upsells, including preorder and
				// any other legitimate product form properties.
				...(Object.keys(form_properties).length ? { properties: form_properties } : {})
			}
		];

		if (isMultiBuyMode) {
			selected_variants[0].quantity = 1;

			productForm.querySelectorAll('[data-multi-buy-group] [data-multi-buy-swatch].selected').forEach((option) => {
				if (!option.dataset.variantId) return;

				const preorderMessage = (option.dataset.preorderMessage || '').trim();
				selected_variants.push({
					id: option.dataset.variantId,
					quantity: 1,
					...(preorderMessage ? { properties: { Preorder: preorderMessage } } : {})
				});
			});
		}

		const upsellInputs = document.querySelectorAll('.product-upsell input');

		upsellInputs.forEach(input => {
			if (input.checked) {
				const selected_variant = {
					quantity: 1,
					id: input.value
				}
				selected_variants.push(selected_variant);
			}
		});

		//console.log('ajax_add_to_cart')
		//console.log(selectedId);
		//console.log(form_properties);

		if (selectedId) {
			setAtcButtonLoading(submitButton);
			// Shopify accepts a single-item items array, so using the multi-add
			// path here keeps the submit flow consistent for single adds and
			// add-with-upsell without splitting property handling in two places.
			addProductsToCart(selected_variants, submitButton);
		}
	});
}
ajax_add_to_cart();

function init_product_upsell(){
	const upsellInputs = document.querySelectorAll('.product-upsell input');
	let productPrice = document.querySelector('.price--main').dataset.price;
	let productComparePrice = document.querySelector('.price--compare-at').dataset.price;

	function updateUpsellPrices(productPrice,productComparePrice){
		const updatedProductPrice = productPrice / 100.00
		const updatedComparePrice = productComparePrice / 100.00
		document.querySelector('.price--main').innerHTML = `$ ${updatedProductPrice.toFixed(2)} ${cart_currency}`;
		document.querySelector('.price--compare-at').innerHTML = `$ ${updatedComparePrice.toFixed(2)} ${cart_currency}`;
	}

	upsellInputs.forEach(input => {
		input.addEventListener('change', () => {
			if (input.dataset.price) {
				if (input.checked) {
					productPrice = Number(productPrice) + Number(input.dataset.price)
					productComparePrice = Number(productComparePrice) + Number(input.dataset.price)
				} else {
					productPrice = document.querySelector('.price--main').dataset.price;
					productComparePrice = document.querySelector('.price--compare-at').dataset.price;
				}
				updateUpsellPrices(productPrice,productComparePrice);
			}
		});

		if (input.classList.contains('auto-add-true')) {
			input.checked = true;
		}

		input.dispatchEvent(new Event('change'));
	});
}
init_product_upsell();

//SKIO Custom

//Skio Sales text:

document.addEventListener('DOMContentLoaded', () => {
	const target = document.querySelector('.skio-group-content');
	if (!target) return;
	if (target.nextElementSibling?.classList.contains('skio-benefits')) return; // prevent duplicate

	const html = `
	<ul class="skio-benefits" style="list-style:none; padding:0;">
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Each box plants 4 trees
		</li>
		<li style="display:none; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Free Shipping on subscriptions
		</li>
		<li style="display:none; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			FREE shipping on every order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Free Gift Every 3rd Order
		</li>
		<li style="display:flex; align-items:center; margin:6px 0;">
			<span style="display:inline-flex; align-items:center; justify-content:center; width:20px; height:20px; margin-right:8px;">
				<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:20px; height:20px; display:block;">
					<circle cx="12" cy="12" r="12" fill="#0ca573"></circle>
					<path d="M17 8.5L10.25 15.25L7 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="transparent"></path>
				</svg>
			</span>
			Cancel anytime
		</li>
	</ul>`;
	target.insertAdjacentHTML('afterend', html);
});

document.addEventListener('DOMContentLoaded', () => {
	const qty = document.querySelector('.quantity-swatches');
	const qtyInput = document.getElementById('product-quantity-input');

	const priceMain = document.querySelector('.price--main');
	if (priceMain) {
		const currentPrice = Number(priceMain.dataset.price);
		const perBar = currentPrice / 1200.00
		document.querySelectorAll('.skio-group-topline').forEach(el => {
			if (el.textContent.includes('Try Once')) {
				el.childNodes.forEach(node => {
					if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Try Once') {
						node.textContent = `Try Once ($${perBar.toFixed(2)} per bar)`;
					}
				});
			}
		});

		if (qty) {
			// Multi pack selector
			document.querySelectorAll('input[name="pack-size"]').forEach(radio => {
				radio.addEventListener('change', e => {
					qtyInput.value = e.target.value;
					discountValue = e.target.dataset.discount;

					const saveTxt = document.querySelector('.skio-save');
					if (saveTxt){
						saveTxt.innerHTML = `Save ${discountValue}%`
					}

					const compareAt = document.querySelector('.price--compare-at');

					if (compareAt) {
						const compareAtPrice = Number(compareAt.dataset.price);
						const salePrice = compareAtPrice * (discountValue / 100) / 100.00;
						const priceTxt = document.querySelector('.skio-price');
						if (priceTxt){
							priceTxt.innerHTML = `$${salePrice.toFixed(2)}`;
						}
					}
				});
			});



			const showQty = () => qty.classList.remove('is-closed');
			const hideQty = () => {
				qty.classList.add('is-closed');
				if (qtyInput) qtyInput.value = 1;
			};

			// Labels
			const oneTimeLabels = document.querySelectorAll('.skio-group-label[for*="skio-one-time"]');
			const otherLabels   = document.querySelectorAll('.skio-group-label[for]:not([for*="skio-one-time"])');

			// Clicks on labels
			oneTimeLabels.forEach(l => l.addEventListener('click', hideQty));
			otherLabels.forEach(l => l.addEventListener('click', showQty));
		} else {
			// Hardcoded for discounted product with just the option to buy 1 pack or subscribe
			const saveTxt = document.querySelector('.skio-save');
			if (saveTxt) {
				saveTxt.innerHTML = `Save 40%`
			}
		}
	}
});
